module.exports = __webpack_public_path__ + "media/images/admin/icons/wifi-off-a661aa6fd0952d01ba9b8a60711b2ecf.svg";